import * as Yup from 'yup';

import { FormValues } from './types';

export const initialValues: FormValues = {
  code: '',
  newEmail: '',
};

export const validationSchema = [
  Yup.object().shape({
    newEmail: Yup.string().email().required(),
  }),
  Yup.object().shape({
    code: Yup.string().required(),
  }),
];
